"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IframeManager = void 0;
const make_iframe_1 = require("./make-iframe");
class IframeManager {
    static init({ providerUrl, onLoad, }) {
        console.debug('IframeManager.constructor', { providerUrl });
        IframeManager._iframe = (0, make_iframe_1.buildIframe)({ origin: providerUrl, onLoad });
    }
    static show() {
        if (!this._iframe)
            throw new Error('IframeManager not initialized');
        Object.assign(this._iframe.style, Object.assign(Object.assign({}, make_iframe_1.baseStyle), { display: 'block' }));
    }
    static hide() {
        if (!this._iframe)
            throw new Error('IframeManager not initialized');
        Object.assign(this._iframe.style, Object.assign(Object.assign({}, make_iframe_1.baseStyle), { display: 'none' }));
    }
    static isVisible() {
        return false;
    }
}
exports.IframeManager = IframeManager;
